// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>',
  created () {
    let lists = localStorage.getItem('lists')
    let tasks = localStorage.getItem('tasks')

    if (lists && lists !== 'undefined' && tasks && tasks !== 'undefined') {
      this.$store.dispatch('preloadContent', {lists, tasks})
    } else {
      this.$store.dispatch('uploadTasksToLocalStorage')
      this.$store.dispatch('uploadListsToLocalStorage')
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js